import { render, staticRenderFns } from "./ProfileWarning.vue?vue&type=template&id=dba29144&scoped=true&"
import script from "./ProfileWarning.vue?vue&type=script&lang=js&"
export * from "./ProfileWarning.vue?vue&type=script&lang=js&"
import style0 from "./ProfileWarning.vue?vue&type=style&index=0&id=dba29144&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba29144",
  null
  
)

export default component.exports